export let hrmsLovColumns = () => {
  let codempidColumns = [
    {
      key: 'codempid',
      name: '',
      labelCodapp: 'LOV_EMP',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codempid',
      name: '',
      labelCodapp: 'LOV_EMP',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_staemp',
      name: '',
      labelCodapp: 'LOV_EMP',
      labelIndex: '4',
      style: 'min-width: 150px;'
    }
  ]
  let codemp9Columns = [
    {
      key: 'codemp9',
      name: '',
      labelCodapp: 'LOV_EMP',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codemp9',
      name: '',
      labelCodapp: 'LOV_EMP',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_staemp',
      name: '',
      labelCodapp: 'LOV_EMP',
      labelIndex: '4',
      style: 'min-width: 150px;'
    }
  ]
  let codempstappColumns = [
    {
      key: 'codempstapp',
      name: '',
      labelCodapp: 'LOV_EMP',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codempstapp',
      name: '',
      labelCodapp: 'LOV_EMP',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_staemp',
      name: '',
      labelCodapp: 'LOV_EMP',
      labelIndex: '4',
      style: 'min-width: 150px;'
    }
  ]

  let codposColumns = [
    {
      key: 'codpos',
      name: '',
      labelCodapp: 'LOV_POS',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'LOV_POS',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]

  let codappColumns = [
    {
      key: 'codapp',
      name: '',
      labelCodapp: 'LOV_CODAPP',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codapp',
      name: '',
      labelCodapp: 'LOV_CODAPP',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]

  let nummemoColumns = [
    {
      key: 'nummemo',
      name: '',
      labelCodapp: 'LOV_MEMO',
      labelIndex: '1',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'dteyear',
      name: '',
      labelCodapp: 'LOV_MEMO',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;',
      dataType: 'year'
    }, {
      key: 'dtemonth',
      name: '',
      labelCodapp: 'LOV_MEMO',
      labelIndex: '3',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'numclseq',
      name: '',
      labelCodapp: 'LOV_MEMO',
      labelIndex: '4',
      class: 'align-center',
      style: 'min-width: 80px;'
    }, {
      key: 'codcours',
      name: '',
      labelCodapp: 'LOV_MEMO',
      labelIndex: '5',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'namcours',
      name: '',
      labelCodapp: 'LOV_MEMO',
      labelIndex: '6',
      style: 'min-width: 200px;'
    }
  ]

  let codcoursColumns = [
    {
      key: 'codcours',
      name: '',
      labelCodapp: 'LOV_CORS',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codcours',
      name: '',
      labelCodapp: 'LOV_CORS',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]

  let codformColumns = [
    {
      key: 'codform',
      name: '',
      labelCodapp: 'LOV_FORM',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codform',
      name: '',
      labelCodapp: 'LOV_FORM',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]

  let numapplColumns = [
    {
      key: 'numappl',
      name: '',
      labelCodapp: 'LOV_APP3',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_numappl',
      name: '',
      labelCodapp: 'LOV_APP3',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_statappl',
      name: '',
      labelCodapp: 'LOV_APP3',
      labelIndex: '4',
      style: 'min-width: 200px;'
    }
  ]

  let numreqColumns = [
    {
      key: 'numreq',
      name: '',
      labelCodapp: 'LOV_REQ3',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'codcomp',
      name: '',
      labelCodapp: 'LOV_REQ3',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }, {
      key: 'codpos',
      name: '',
      labelCodapp: 'LOV_REQ3',
      labelIndex: '4',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codpos',
      name: '',
      labelCodapp: 'LOV_REQ3',
      labelIndex: '5',
      style: 'min-width: 200px;'
    }
  ]
  let codaplvlColumns = [
    {
      key: 'codaplvl',
      name: '',
      labelCodapp: 'LOV_APLV',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codaplvl',
      name: '',
      labelCodapp: 'LOV_APLV',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let grdscorColumns = [
    {
      key: 'grditem',
      name: '',
      labelCodapp: 'HRAP31EC6',
      labelIndex: '250',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_grdscor',
      name: '',
      labelCodapp: 'HRAP31EC6',
      labelIndex: '260',
      style: 'min-width: 150px;'
    }, {
      key: 'qtyscor',
      name: '',
      labelCodapp: 'HRAP31EC6',
      labelIndex: '270',
      class: 'align-right',
      style: 'min-width: 100px;'
    }
  ]
  let grditemColumns = [
    {
      key: 'grditem',
      name: '',
      labelCodapp: 'HRAP31EC6',
      labelIndex: '250',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_grditem',
      name: '',
      labelCodapp: 'HRAP31EC6',
      labelIndex: '260',
      style: 'min-width: 150px;'
    }, {
      key: 'qtyscor',
      name: '',
      labelCodapp: 'HRAP31EC6',
      labelIndex: '270',
      class: 'align-right',
      style: 'min-width: 100px;'
    }
  ]
  let codapprColumns = [
    {
      key: 'codappr',
      name: '',
      labelCodapp: 'LOV_CODAPPR',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codappr',
      name: '',
      labelCodapp: 'LOV_CODAPPR',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_staemp',
      name: '',
      labelCodapp: 'LOV_CODAPPR',
      labelIndex: '4',
      style: 'min-width: 150px;'
    }
  ]
  let codshiftColumns = [
    {
      key: 'codshift',
      name: '',
      labelCodapp: 'LOV_SHIF',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codshift',
      name: '',
      labelCodapp: 'LOV_SHIF',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }, {
      key: 'schedule',
      name: '',
      labelCodapp: 'LOV_SHIF',
      labelIndex: '4',
      class: 'align-center',
      style: 'min-width: 150px;'
    }
  ]
  let codroomColumns = [
    {
      key: 'codroom',
      name: '',
      labelCodapp: 'LOV_ROOM',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codroom',
      name: '',
      labelCodapp: 'LOV_ROOM',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let codassetColumns = [
    {
      key: 'codasset',
      name: '',
      labelCodapp: 'LOV_ASSET',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codasset',
      name: '',
      labelCodapp: 'LOV_ASSET',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let codcalenColumns = [
    {
      key: 'codcalen',
      name: '',
      labelCodapp: 'LOV_WORK',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codcalen',
      name: '',
      labelCodapp: 'LOV_WORK',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let codcompyColumns = [
    {
      key: 'codcompy',
      name: '',
      labelCodapp: 'LOV_COMP',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codcompy',
      name: '',
      labelCodapp: 'LOV_COMP',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let batchnoColumns = [
    {
      key: 'batchno',
      name: '',
      labelCodapp: 'LOV_BATCH',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'entrydte',
      name: '',
      labelCodapp: 'LOV_BATCH',
      labelIndex: '3',
      style: 'min-width: 200px;',
      dataType: 'date'
    }, {
      key: 'lastseq',
      name: '',
      labelCodapp: 'LOV_BATCH',
      labelIndex: '4',
      style: 'min-width: 200px;'
    }
  ]
  let costcentColumns = [
    {
      key: 'costcent',
      name: '',
      labelCodapp: 'LOV_COSTCENT',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_costcent',
      name: '',
      labelCodapp: 'LOV_COSTCENT',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let codbrlcColumns = [
    {
      key: 'codbrlc',
      name: '',
      labelCodapp: 'LOV_LOCA',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_codbrlc',
      name: '',
      labelCodapp: 'LOV_LOCA',
      labelIndex: '3',
      style: 'min-width: 100px;'
    }
  ]
  let codtencyColumns = [
    {
      key: 'codtency',
      name: '',
      labelCodapp: 'LOV_TNCY',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codtency',
      name: '',
      labelCodapp: 'LOV_TNCY',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let codedlvColumns = [
    {
      key: 'codedlv',
      name: '',
      labelCodapp: 'LOV_EDUC',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 150px;'
    }, {
      key: 'desc_codedlv',
      name: '',
      labelCodapp: 'LOV_EDUC',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let codjobColumns = [
    {
      key: 'codjob',
      name: '',
      labelCodapp: 'LOV_JOB',
      labelIndex: '2',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codjob',
      name: '',
      labelCodapp: 'LOV_JOB',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let codempmtColumns = [
    {
      key: 'codempmt',
      name: '',
      labelCodapp: 'LOV_EMPL',
      labelIndex: '2',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codempmt',
      name: '',
      labelCodapp: 'LOV_EMPL',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let typempColumns = [
    {
      key: 'typemp',
      name: '',
      labelCodapp: 'LOV_CATG',
      labelIndex: '2',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_typemp',
      name: '',
      labelCodapp: 'LOV_CATG',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let typpayrollColumns = [
    {
      key: 'typpayroll',
      name: '',
      labelCodapp: 'LOV_TYPY',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_typpayroll',
      name: '',
      labelCodapp: 'LOV_TYPY',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let codinstColumns = [
    {
      key: 'codinst',
      name: '',
      labelCodapp: 'LOV_INST',
      labelIndex: '2',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codinst',
      name: '',
      labelCodapp: 'LOV_INST',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let staempColumns = [
    {
      key: 'staemp',
      name: '',
      labelCodapp: 'LOV_STAEMP',
      labelIndex: '2',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_staemp',
      name: '',
      labelCodapp: 'LOV_STAEMP',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let coddomclColumns = [
    {
      key: 'coddomcl',
      name: '',
      labelCodapp: 'LOV_PROV',
      labelIndex: '2',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_coddomcl',
      name: '',
      labelCodapp: 'LOV_PROV',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let codprovrColumns = [
    {
      key: 'codprovr',
      name: '',
      labelCodapp: 'LOV_PROV',
      labelIndex: '2',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_codprovr',
      name: '',
      labelCodapp: 'LOV_PROV',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let typleaveColumns = [
    {
      key: 'typleave',
      name: '',
      labelCodapp: 'LOV_LVTY',
      labelIndex: '2',
      style: 'min-width: 200px;'
    }, {
      key: 'desc_typleave',
      name: '',
      labelCodapp: 'LOV_LVTY',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]
  let courstrainColumns = [
    {
      key: 'courstrain',
      name: '',
      labelCodapp: 'LOV_CORS',
      labelIndex: '2',
      class: 'align-center',
      style: 'min-width: 100px;'
    }, {
      key: 'desc_courstrain',
      name: '',
      labelCodapp: 'LOV_CORS',
      labelIndex: '3',
      style: 'min-width: 200px;'
    }
  ]

  return {
    en: {
      codempid: codempidColumns,
      codemp9: codemp9Columns,
      codempstapp: codempstappColumns,
      codpos: codposColumns,
      codapp: codappColumns,
      nummemo: nummemoColumns,
      codcours: codcoursColumns,
      codform: codformColumns,
      numappl: numapplColumns,
      numreq: numreqColumns,
      codaplvl: codaplvlColumns,
      grdscor: grdscorColumns,
      grditem: grditemColumns,
      codappr: codapprColumns,
      codshift: codshiftColumns,
      codroom: codroomColumns,
      codasset: codassetColumns,
      codcalen: codcalenColumns,
      codcompy: codcompyColumns,
      batchno: batchnoColumns,
      costcent: costcentColumns,
      codbrlc: codbrlcColumns,
      codtency: codtencyColumns,
      codedlv: codedlvColumns,
      codjob: codjobColumns,
      codempmt: codempmtColumns,
      typemp: typempColumns,
      typpayroll: typpayrollColumns,
      codinst: codinstColumns,
      staemp: staempColumns,
      coddomcl: coddomclColumns,
      codprovr: codprovrColumns,
      typleave: typleaveColumns,
      courstrain: courstrainColumns
    },
    th: {
      codempid: codempidColumns,
      codemp9: codemp9Columns,
      codempstapp: codempstappColumns,
      codpos: codposColumns,
      codapp: codappColumns,
      nummemo: nummemoColumns,
      codcours: codcoursColumns,
      codform: codformColumns,
      numappl: numapplColumns,
      numreq: numreqColumns,
      codaplvl: codaplvlColumns,
      grdscor: grdscorColumns,
      grditem: grditemColumns,
      codappr: codapprColumns,
      codshift: codshiftColumns,
      codroom: codroomColumns,
      codasset: codassetColumns,
      codcalen: codcalenColumns,
      codcompy: codcompyColumns,
      batchno: batchnoColumns,
      costcent: costcentColumns,
      codbrlc: codbrlcColumns,
      codtency: codtencyColumns,
      codedlv: codedlvColumns,
      codjob: codjobColumns,
      codempmt: codempmtColumns,
      typemp: typempColumns,
      typpayroll: typpayrollColumns,
      codinst: codinstColumns,
      staemp: staempColumns,
      coddomcl: coddomclColumns,
      codprovr: codprovrColumns,
      typleave: typleaveColumns,
      courstrain: courstrainColumns
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/columns/hrmsLov.js